import {AutomatedCommentSource, type AutomatedCommentSourceType} from '../types'
import {
  pluralizedTexts,
  ALERT_ENTITY,
  FINDING_ENTITY,
  type DismissalEntity,
} from '@github-ui/shared-dismissal/pluralized-texts'

function entityForSource(source: AutomatedCommentSourceType): DismissalEntity {
  switch (source) {
    case AutomatedCommentSource.CodeScanning:
      return ALERT_ENTITY
    default:
      return FINDING_ENTITY
  }
}

export function dialogTextsForSource(source: AutomatedCommentSourceType, delegatedDismissalEnabled: boolean) {
  if (source === AutomatedCommentSource.LicenseCompliance) {
    return {
      title: 'Request to close license alert',
      subtitle: 'This alert needs approval before it can be closed. Requests are sent to all approvers.',
      submitButtonLabel: 'Submit request',
    }
  }

  const entity = entityForSource(source)
  const {title, subtitle, submitButtonLabel, delegatedAlertDismissal} = pluralizedTexts(entity, 1)

  if (delegatedDismissalEnabled) {
    return {
      title: delegatedAlertDismissal.title,
      subtitle: delegatedAlertDismissal.subtitle,
      submitButtonLabel: delegatedAlertDismissal.submitButtonLabel,
    }
  }

  return {title, subtitle, submitButtonLabel}
}
